import React from "react";
class Mobile extends React.Component {
  render() {
    return (
      <main>
        <div className="mainBody">
          <div className="bannerBlock">
            <div
              style={{
                position: "absolute",
                right: "0px",
                width: "250px",
                height: "150px",
                backgroundimage: "url(images/Services.png)",
                backgroundposition: "-0px -100px",
              }}
            ></div>
            <div className="bannerContent">
              <div class="content">
                <span class="pageTitle">MOBILE TECHNOLOGY</span>
                <br />
                <span class="subTitle">
                  Building intelligent, cross-platform mobile solutions powered by AI
                  <br />
                  and modern cloud infrastructure...
                </span>
              </div>
            </div>
          </div>
          <div className="content padSmall">
            <p>
              At Sarithm, we develop cutting-edge mobile applications that leverage AI tools 
              and modern cloud infrastructure to deliver exceptional user experiences across 
              iOS and Android platforms. Our mobile solutions are built with intelligence, 
              scalability, and cost-effectiveness at their core.
            </p>
            <p>
              <b>AI-Enhanced Mobile Development:</b> We use <b>Cursor</b> to accelerate our mobile 
              development process, enabling faster code generation, intelligent refactoring, and 
              context-aware suggestions for React Native and native mobile projects. This AI-powered 
              approach allows us to build feature-rich applications in less time while maintaining 
              high code quality standards.
            </p>
            <p>
              <b>Cross-Platform Excellence:</b> Our expertise in <b>React Native</b> enables us to 
              build applications that run seamlessly on both iOS and Android devices from a single 
              codebase. This approach significantly reduces development time and costs while ensuring 
              consistent user experiences across platforms. We leverage AI tools during development 
              to optimize performance, detect platform-specific issues, and ensure code quality.
            </p>
            <p>
              <b>Intelligent Backend Integration:</b> Our mobile applications are powered by 
              <b> AWS Serverless Architecture</b>, providing scalable, cost-effective backend services. 
              We integrate <b>n8n</b> workflows to automate data synchronization, push notifications, 
              and real-time updates. <b>ChatGPT</b> and other LLMs enhance our mobile apps with 
              intelligent chatbots, natural language processing, and automated content generation 
              capabilities.
            </p>
            <p>
              <b>Real-World Success:</b> Our <b>Haulr</b> mobile application demonstrates our expertise 
              in building intelligent, location-aware solutions. The app brings Construction and Trucking 
              Companies together on one platform, enabling truckers to find work efficiently and 
              contractors to locate trucks faster. AI-powered features include intelligent conflict 
              resolution through automated logging of truck locations, ClockIn/ClockOut times, and 
              real-time visibility for onsite supervisors.
            </p>
            <p>
              <b>Rapid Development and Deployment:</b> By combining AI-enhanced development tools with 
              cloud-native infrastructure, we deliver mobile solutions faster with shorter feedback 
              cycles. Our automated CI/CD pipelines, powered by AI-driven testing and quality checks, 
              ensure reliable deployments and continuous improvement.
            </p>
            <p>
              Whether you need a native iOS app, Android application, or cross-platform solution, 
              we deliver mobile experiences that are intelligent, scalable, and built for the future.
            </p>
            <br />
            <br />
            <br />
          </div>
        </div>
        <div style={{ clear: "both" }}></div>
      </main>
    );
  }
}
export default Mobile;
